var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3552 23.8234C16.0678 23.8234 18.6693 22.7458 20.5874 20.8277C22.5054 18.9096 23.583 16.3081 23.583 13.5955C23.583 10.8829 22.5054 8.28144 20.5874 6.36334C18.6693 4.44525 16.0678 3.36768 13.3552 3.36768C10.6426 3.36768 8.04108 4.44525 6.12299 6.36334C4.20489 8.28144 3.12732 10.8829 3.12732 13.5955C3.12732 16.3081 4.20489 18.9096 6.12299 20.8277C8.04108 22.7458 10.6426 23.8234 13.3552 23.8234ZM14.6336 8.4816C14.6336 8.14253 14.499 7.81734 14.2592 7.57758C14.0194 7.33782 13.6942 7.20312 13.3552 7.20312C13.0161 7.20312 12.6909 7.33782 12.4511 7.57758C12.2114 7.81734 12.0767 8.14253 12.0767 8.4816V13.5955C12.0768 13.9346 12.2115 14.2597 12.4513 14.4994L16.0668 18.1162C16.1856 18.235 16.3266 18.3292 16.4818 18.3935C16.637 18.4578 16.8034 18.4909 16.9714 18.4909C17.1393 18.4909 17.3057 18.4578 17.4609 18.3935C17.6161 18.3292 17.7571 18.235 17.8759 18.1162C17.9947 17.9975 18.0889 17.8564 18.1532 17.7012C18.2175 17.546 18.2505 17.3797 18.2505 17.2117C18.2505 17.0437 18.2175 16.8774 18.1532 16.7222C18.0889 16.567 17.9947 16.426 17.8759 16.3072L14.6336 13.0662V8.4816Z",
    fill: "#E5B910"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesClock);
export default __webpack_public_path__ + "static/media/devices-clock.33123662b3b545eb9975b8f38fe92bb7.svg";
export { ForwardRef as ReactComponent };